module.exports = __webpack_public_path__ + "img/3c928b417939d93b995ee6b619392948.svg";